// extracted by mini-css-extract-plugin
export default {"user__summary":"UserOrderDetailsSummary_user__summary__+QELo"};